import { computed } from 'vue'

export default function UseUserAuth (user) {
    const isAdmin = computed(() => {
        if (!user) {
            return false;
        }

        return user.roles.find(r => r.name === 'admin') ? true : false;
    });

    const isCustomer = computed(() => {
        if (!user) {
            return false;
        }

        return user.roles.find(r => r.name === 'customer') ? true : false;
    });

    const isLogistics = computed(() => {
        if (!user) {
            return false;
        }

        return user.roles.find(r => r.name === 'logistics') ? true : false;
    });

    const isLocation = computed(() => {
        if (!user) {
            return false;
        }

        return user.roles.find(r => r.name === 'location') ? true : false;
    });

    const isPicker = computed(() => {
        if (!user) {
            return false;
        }

        return (user.roles.find(r => r.name === 'picker') ? true : false);
    });

    const isOnlyPicker = computed(() => {
        if (!user) {
            return false;
        }

        return (user.roles.find(r => r.name === 'picker') ? true : false) && user.roles.length === 1;
    });

    const hasReportsRole = computed(() => {
        if (!user) {
            return false;
        }

        return user.roles.find(r => r.name === 'reports') ? true : false;
    });

    const hasFinanceRole = computed(() => {
        if (!user) {
            return false;
        }

        return user.roles.find(r => r.name === 'finance') ? true : false;
    });

    const hasRole = (role) => {
        if (!user) {
            return false;
        }

        return user.roles.find(r => r.name === role) ? true : false;
    };

    return {
        isAdmin,
        isCustomer,
        isLogistics,
        isLocation,
        isPicker,
        isOnlyPicker,
        hasReportsRole,
        hasFinanceRole,
        hasRole
    };
}
